'use client';

import { Box } from '@coolblue-development/freddy';
import { useAddToCartSteps } from '@features/add-to-cart-page/components/AddToCartSteps/AddToCartStepsProvider';
import useTestId from '@hooks/useTestId';

type Props = {
  children: React.ReactNode;
};

export function InsuranceSectionBox({ children }: Props) {
  const testId = useTestId('insurance-section');
  const { hasMultiStep } = useAddToCartSteps();

  return (
    <Box {...testId} mt={800} component='section' {...(hasMultiStep && { mb: '25vh' })}>
      {children}
    </Box>
  );
}
